<div class="status-wrap">
    @if (showStatusText) {
        <span>{{ stateText }}</span>
    }
    <span class="resource-state {{currentStatus}}"
          [title]="statusTooltip">
                <app-icon [icon]="fontAwesomeGlyph" [spin]="isStatusUnstable" size="xl"></app-icon>
    </span>
    @if (showAnalyze) {
        <button
            class="analyze-failure-btn"
            type="button"
            title="Analyze Failure"
            aria-label="Analyze Failure"
            (click)="onAnalyze($event)">
            <fd-icon glyph="ai" class="ai-assistant-glyph"></fd-icon>
        </button>
    }
</div>
